<template>
  <div class="rel loading">
    <Top></Top>
    <div class="abs auto progress">
      <div class="abs total">
        <div class="abs curr" :style="{ width: progress + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/components/top/Top.vue'

export default {
  data(){
    return {
      images: [
        'awardWaitTip.png',
        'capsuleToyFinallyConfirm.png',
        'capsuleToyFinallyTip.png',
        'capsuleToyNOResult.png',
        'capsuleToyNOResultConfirm.png',
        'capsuleToyNOTicket.png',
        'capsuleToyNOTicketConfirm.png',
        'capsuleToys.gif',
        'CapsuleToySuccess.png',
        'capsuleToySuccessConfirm.png',
        'capsuleToySuccessTip.png',
        'entry.png',
        'entryTip.png',
        'friend.png',
        'getHead.jpg',
        'getProgressAward.png',
        'getProgressAwardAll.png',
        'HeadDetails.png',
        'headList.jpg',
        'home.jpg',
        'icon_new.png',
        'icon_select.png',
        'icon_user.png',
        'loading.jpg',
        'popBind.png',
        'popClose.png',
        'popRule.png',
        'progress.png',
        'progress1.png',
        'progress2.png',
        'progress3.png',
        'progress4.png',
        'progressAward1.png',
        'progressAward2.png',
        'progressAward3.png',
        'progressAward4.png',
        'progressCurr.png',
        'ruleBtn.png',
        'share.png',
        'shareAfterBtn.png',
        'shareAfterTip.png',
        'shareBeforeBtn.png',
        'shareBeforeTip.png',
        'start.png',
        'toGetHead.png',
        'toHeadList.png',
        'wrapper.jpg',
        'head/1.jpg',
        'head/2.jpg',
        'head/3.jpg',
        'head/4.jpg',
        'head/5.jpg',
        'head/6.jpg',
        'head/7.jpg',
        'head/8.jpg',
        'head/9.jpg',
        'head/10.jpg',
        'head/11.jpg',
        'head/12.jpg',
        'head/13.jpg',
        'head/14.jpg',
        'head/15.jpg',
        'head/16.jpg',
        'head/17.jpg',
        'head/18.jpg',
        'head/19.jpg',
        'head/20.jpg',
        'head/21.jpg',
        'head/22.jpg',
        'head/23.jpg',
        'head/24.jpg',
        'head/25.jpg',
        'head/26.jpg',
        'head/27.jpg',
        'head/28.jpg',
        'head/29.jpg',
        'head/30.jpg',
        'head/31.jpg',
        'head/32.jpg',
        'head/33.jpg',
        'guide/guidePage1.jpg',
        'guide/guidePage2.jpg',
        'guide/guidePage3.jpg',
        'guide/guidePage4.jpg',
        'guide/guidePage5.jpg',
        'guide/IKnow.png',
      ],
      progress: 0,   // 进度条百分比
      loadedImages: 0,  // 已加载的图片数量
      totalImages: 0,    // 总图片数量
      minTime: 1000,
      timeEnd: false,
      imgEnd: false
    }
  },
  components: {
    Top
  },
  mounted(){
    // 获取图片总数
    this.totalImages = this.images.length;

    // 加载所有图片
    this.images.forEach(image => {
      this.loadImage(image);
    });

    setTimeout(() => {
      this.timeEnd = true;
      this.loadEnd();
    }, this.minTime)
  },
  methods: {
    // 加载单张图片
    loadImage(image) {
      const img = new Image();
      img.onload = () => {
        this.onImageLoaded();
      };
      img.onerror = () => {
        this.onImageLoaded(); // 即使加载失败，也算作完成
      };
      img.src = require(`@images/${image}`);  // 动态加载图片
    },

    // 每当一张图片加载完成时，更新进度条
    onImageLoaded() {
      this.loadedImages++;
      this.progress = (this.loadedImages / this.totalImages) * 100;  // 计算加载进度

      // 当所有图片加载完成时，结束进度条
      if (this.loadedImages === this.totalImages) {
        this.imgEnd = true;
        this.loadEnd();
      }
    },

    loadEnd(){
      if(this.timeEnd && this.imgEnd){
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped>
.loading{ height: 100%; background: url(@images/loading.jpg) no-repeat center top;}
.progress{ top: 789px; width: 577px; height: 118px; background: url(@images/progress.png) no-repeat 0 0;}
.total{ top: 6px; left: 6px; width: 566px; height: 53px;}
.curr{ top: 0; left: 0; height: 100%; width: 10%; background: url(@images/progressCurr.png) no-repeat left center; background-size: auto 100%; border-radius: 27px; overflow: hidden;}
</style>